import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Travaelspartnersprogramsinpune() {



  const cardData =
  {
    keyword: ' Travels Partners Program in Pune ',
    heading: 'Pune Corporate Cars India Private Limited: Travels Partners Program in Pune ',
    headingDescription: 'Pune Corporate Cars India Private Limited offers a professional and rewarding Travel Partners Program in Pune, enabling travel agencies, hotel travel desks, corporate vendors, event managers, and business associates to collaborate and provide reliable transportation services across the city. Through this program, partners gain access to a large fleet of well-maintained sedans, SUVs, MUVs, luxury cars, and corporate vehicles for business travel, airport transfers, employee transportation, VIP movements, delegations, and event mobility. We provide competitive pricing, real-time support, flexible billing options, professional chauffeurs, and reliable service delivery, ensuring partners can confidently serve their clients with superior travel solutions. With transparent operations, consistent service quality, and a dedicated relationship management team, Pune Corporate Cars India Private Limited builds strong, long-term partnerships that drive success for travel providers throughout Pune.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

"topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],


"services": [
  {
    "name": "Corporate Travel Partnership Pune",
    "description": "Corporate Travel Partnership Pune provides strategic collaborations between companies and travel service providers, enabling streamlined corporate travel management, negotiated rates, and dedicated support for employee mobility."
  },
  {
    "name": "Travel Agency Partner Pune",
    "description": "Travel Agency Partner Pune connects businesses with professional travel agencies to manage corporate trips, cab bookings, hotel transfers, and logistics efficiently with a single point of contact."
  },
  {
    "name": "Hotel Travel Desk Partnership Pune",
    "description": "Hotel Travel Desk Partnership Pune offers tie-ups with hotels to provide seamless airport transfers, guest pickups, and corporate transport services integrated with the hotel travel desk."
  },
  {
    "name": "Business Cab Vendor Pune",
    "description": "Business Cab Vendor Pune enables companies to onboard reliable corporate cab vendors for office commute, airport transfers, and client meetings with verified vehicles and trained chauffeurs."
  },
  {
    "name": "Employee Transport Vendor Pune",
    "description": "Employee Transport Vendor Pune helps organizations collaborate with vendors providing structured employee commuting solutions, including shuttle services, daily pickup/drop, and fleet management."
  },
  {
    "name": "Fleet Owner Partnership Pune",
    "description": "Fleet Owner Partnership Pune facilitates partnerships with fleet owners to expand corporate mobility networks, ensuring vehicle availability, maintenance support, and fleet scalability for corporate clients."
  },
  {
    "name": "Logistics Travel Partner Pune",
    "description": "Logistics Travel Partner Pune provides integrated transport and travel solutions for corporate logistics, staff transfers, and event-based mobility, combining efficiency with professional service standards."
  },
  {
    "name": "Corporate Travel Alliance Pune",
    "description": "Corporate Travel Alliance Pune creates networks of corporate travel providers to offer competitive pricing, centralized billing, and enhanced employee transport services for businesses."
  },
  {
    "name": "Cab Vendor Onboarding Pune",
    "description": "Cab Vendor Onboarding Pune supports companies in onboarding and managing cab vendors, including vehicle verification, driver management, route planning, and service compliance for corporate commuting."
  },
  {
    "name": "Travel Collaboration Pune",
    "description": "Travel Collaboration Pune offers partnership opportunities for businesses to collaborate with travel service providers, ensuring cost-effective, organized, and scalable corporate travel solutions."
  },
  {
    "name": "Travel Supplier Program Pune",
    "description": "Travel Supplier Program Pune establishes structured programs for corporate travel suppliers, facilitating partnerships, operational efficiency, and standardized service delivery for business clients."
  },
  {
    "name": "Enterprise Travel Network Pune",
    "description": "Enterprise Travel Network Pune provides a network of trusted corporate travel providers, ensuring seamless coordination, optimized routes, and quality travel services for employees across multiple locations."
  },
  {
    "name": "B2B Travel Cab Partner Pune",
    "description": "B2B Travel Cab Partner Pune enables businesses to access certified cab operators for corporate travel requirements, offering reliable services, scalable fleet options, and competitive pricing."
  },
  {
    "name": "Transport Franchise Pune",
    "description": "Transport Franchise Pune provides opportunities for entrepreneurs to operate corporate transportation services under a recognized brand, with training, fleet support, and operational guidance for successful franchise management."
  },
  {
    "name": "Corporate Fleet Partnership Pune",
    "description": "Corporate Fleet Partnership Pune allows organizations to collaborate on fleet management, sharing vehicles, drivers, and logistics solutions to enhance operational efficiency and employee transport services."
  }
],

"tableData": [
  ["Corporate Travel Partnership Pune", "Travel Agency Partner Pune"],
  ["Hotel Travel Desk Partnership Pune", "Business Cab Vendor Pune"],
  ["Employee Transport Vendor Pune", "Fleet Owner Partnership Pune"],
  ["Logistics Travel Partner Pune", "Corporate Travel Alliance Pune"],
  ["Cab Vendor Onboarding Pune", "Travel Collaboration Pune"],
  ["Travel Supplier Program Pune", "Enterprise Travel Network Pune"],
  ["B2B Travel Cab Partner Pune", "Transport Franchise Pune"],
  ["Corporate Fleet Partnership Pune", ""]
],





  





"whychoose": [
  {
    "WhyChooseheading": "Travels Partners Program in Pune",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers a dedicated Travels Partners Program in Pune, designed to provide seamless collaboration with travel agencies, hotels, and corporate partners for efficient transportation solutions."
  },
  {
    "WhyChooseheading": "Reliable & Timely Services",
    "WhyChoosedescription": "Our program ensures punctual pickups and drop-offs for all partnered travel requirements, helping clients reach offices, hotels, airports, and event venues on time."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs offer safe, courteous, and disciplined travel, delivering a secure and comfortable commuting experience for all partnered travel clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for reliable and comfortable travel under the Partners Program in Pune."
  },
  {
    "WhyChooseheading": "Customized Travel Solutions",
    "WhyChoosedescription": "We provide flexible and tailored travel solutions to meet the specific transportation needs of our travel partners and their clients."
  },
  {
    "WhyChooseheading": "24/7 Partner Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted service for our travel partners."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, offering secure and hygienic rides for our partners and their clients."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Travel management is streamlined through our reliable booking system and coordination, making transportation hassle-free for all partners."
  }
]





















  }

  
const faqData = [
  {
    question: 'What is the Travels Partners Program in Pune?',
    answer: 'The Travels Partners Program by Pune Corporate Cars India Private Limited is designed to collaborate with travel agencies, corporate clients, and partners to provide reliable and professional transportation solutions across Pune.',
  },
  {
    question: 'Who can join the Travels Partners Program?',
    answer: 'Travel agencies, corporate HR teams, event planners, and businesses looking for dependable transportation solutions can join our program.',
  },
  {
    question: 'What benefits do partners receive under this program?',
    answer: 'Partners get access to discounted corporate rates, priority booking, dedicated support, flexible payment options, and seamless fleet management solutions.',
  },
  {
    question: 'How can a company or agency enroll in the program?',
    answer: 'Enrollment can be done via our website, mobile app, or by contacting our 24×7 corporate support team for assistance and program details.',
  },
  {
    question: 'Does the program cover employee transport and corporate events?',
    answer: 'Yes, partners can leverage our services for employee transportation, conference and delegation travel, wedding and event transport, and airport transfers.',
  },
  {
    question: 'Are the vehicles GPS-enabled and professionally managed?',
    answer: 'All vehicles under the program are GPS-enabled, regularly sanitized, and driven by trained and verified chauffeurs to ensure safety and efficiency.',
  },
  {
    question: 'Is there support for last-minute or urgent bookings?',
    answer: 'Absolutely. The program provides flexible solutions for urgent bookings, changes in schedule, or additional vehicle requirements.',
  },
  {
    question: 'Are there long-term partnership contracts available?',
    answer: 'Yes, we offer flexible monthly, quarterly, and annual partnership contracts with transparent pricing and priority fleet allocation.',
  },
  {
    question: 'What payment options are available for program partners?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and provide consolidated invoicing for partners.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ashwin Kulkarni',
    feedback: 'The Travels Partners Program is fantastic. Our company has benefited from timely, professional, and cost-effective transportation solutions in Pune.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Ritu Verma',
    feedback: 'Excellent partnership program. Dedicated support and reliable fleet make it a top choice for corporate travel management.',
    rating: 5,
  },
];


















































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Travels Partners Program in Pune",
  "image": "https://www.punecorporatecars.com/assets/images/travel-partners-program-pune.jpg", // replace with actual image URL
  "description":
    "Pune Corporate Cars India Private Limited offers an exclusive Travel Partners Program for businesses and travel agencies in Pune. This program connects with travel suppliers, fleet owners, and corporate travel partners to provide high-quality transport solutions. Whether you’re looking to partner as a travel agency, hotel travel desk, employee transport vendor, or logistics partner, our program offers seamless onboarding and collaboration for mutual growth.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "0",  // Free program (can be adjusted based on real pricing)
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/travel-partners-program-pune"
  }
};





  return (
    <div>

<Helmet>
  <title>Travels Partners Program in Pune | Corporate Travel Partnership</title>

  <meta
    name="description"
    content="Join the Pune Corporate Cars India Private Limited Travel Partners Program for seamless collaboration. Whether you're a travel agency, hotel desk, fleet owner, or logistics partner, grow with us through corporate travel alliances and more."
  />

  <meta
    name="keywords"
    content="Corporate Travel Partnership Pune, Travel Agency Partner Pune, Hotel Travel Desk Partnership Pune, Business Cab Vendor Pune, Employee Transport Vendor Pune, Fleet Owner Partnership Pune, Logistics Travel Partner Pune, Corporate Travel Alliance Pune, Cab Vendor Onboarding Pune, Travel Collaboration Pune, Travel Supplier Program Pune, Enterprise Travel Network Pune, B2B Travel Cab Partner Pune, Transport Franchise Pune, Corporate Fleet Partnership Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/109.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Travaelspartnersprogramsinpune;